import { useEffect } from 'react';

const useEngInput = (inputRef) => {
  const handleKeyDown = (e) => {
    const englishPattern = /^[a-zA-Z\s]$/; // Allow English letters and space
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete', 'Tab', 'Escape']; // Added Tab and Escape as common keys

    // Check if the key is allowed or if it's a space character or an English letter
    if (!englishPattern.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
      return () => {
        inputRef.current.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [inputRef]);

  return handleKeyDown;
};

export default useEngInput;
